import React from "react";
import {
  Params,
  SetURLSearchParams,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

export interface WithRouterProps {
  params: Readonly<Params<string>>;
  navigate: ReturnType<typeof useNavigate>;
  location: ReturnType<typeof useLocation>;
  searchParams: URLSearchParams;
  setSearchParams: SetURLSearchParams;
}

export function withRouter<P extends WithRouterProps>(
  Component: React.ComponentType<P>
): React.ComponentType<Omit<P, keyof WithRouterProps>> {
  const WithRouterComponent = (props: Omit<P, keyof WithRouterProps>) => {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    return (
      <Component
        {...(props as P)}
        params={params}
        navigate={navigate}
        location={location}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
      />
    );
  };

  WithRouterComponent.displayName = `withRouter(${
    Component.displayName || Component.name
  })`;

  return WithRouterComponent;
}
